import React, {useRef} from 'react';
import {connect} from 'react-redux';
import { CDN_PATH } from '../../../constants/variables';

const mapStateToProps = (state) => {
    return {
        deviceWidth: state.App.deviceWidth,
    }
}

const appendMediaCdnPrefix = (link) => {
    if (link.startsWith("http://") || link.startsWith("https://"))
        return link;

    return `${CDN_PATH}S7PCabinService/media/${link}`;
}

const VideoBanner = ({videoBannerDesktop, videoBannerMobile, videoDesktopLink, videoMobileLink, videoBannerDesktopOverlay, videoBannerMobileOverlay, deviceWidth, isFirstMount}) => {
    const videoRef = useRef(null);
    const isMobile = deviceWidth < 768;
    const link = isMobile && !!videoBannerMobile && !!videoMobileLink ? videoMobileLink : !isMobile && !!videoBannerDesktop && !!videoDesktopLink ? videoDesktopLink : '';

    const startDownload = () => {
        setTimeout(() => {
            if (videoRef.current.readyState !== 4) {
                videoRef.current.pause();
                videoRef.current.remove();
            }
        }, 5000);
    };
    return (
        <>
            { link && !window.document.documentMode && !isFirstMount &&
                <video
                    ref={videoRef}
                    src={appendMediaCdnPrefix(link)}
                    loop
                    muted
                    onLoadStart={startDownload}
                    autoPlay
                    playsInline
                    width="100%"
                    height={isMobile ? "178px" : "380px"}
                    style={{
                        objectFit: 'cover',
                        zIndex: 1,
                        position: 'absolute',
                        filter: isMobile && !!videoBannerMobileOverlay ? `brightness(${videoBannerMobileOverlay})`
                        : !isMobile && !!videoBannerDesktopOverlay ? `brightness(${videoBannerDesktopOverlay})`: null,
                    }}
                >
                </video>
            }
        </>
    );
};

export default connect(mapStateToProps)(React.memo(VideoBanner));
